import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentsServe, TabSize } from 'src/app/utils/constants';
import { PageTab, TypeService } from 'src/app/utils/enums';
import { Gallery, Services } from 'src/app/utils/models';

@Component({
  selector: 'shared-right-card',
  templateUrl: './right-card.component.html',
  styleUrls: ['./right-card.component.scss'],
})
export class RightCardComponent {
  @Input() galleryList: Gallery[];
  @Input() servicesList: Services[];
  cache: string;
  @Input() currentScroll: number;
  @Input() currentTab: number;
  @Output() currentTabChange: EventEmitter<number>;
  @Output() statusScroll: EventEmitter<number>;

  constructor() {
    this.galleryList = [];
    this.servicesList = [];
    this.cache = '?nocache=' + Math.random();

    this.currentScroll = 0;
    this.currentTab = PageTab.PRESENTATION;
    this.statusScroll = new EventEmitter<number>();
    this.currentTabChange = new EventEmitter<number>();
  }

  urlService(index: number): string {
    if (this.servicesList[index].idTipoServicio === TypeService.DOCUMENT) {
      return (
        DocumentsServe.DOCUMENTS +
        this.servicesList[index].idTarjeta +
        '/' +
        this.servicesList[index].urlServicio
      );
    }
    return this.servicesList[index].urlServicio;
  }

  imageService(index: number): string {
    if (this.servicesList[index].urlIcono === '') {
      return (
        DocumentsServe.IMAGESSERVICES +
        this.servicesList[index].idTarjeta +
        '/' +
        this.servicesList[index].urlImagen +
        this.cache
      );
    }
    return '../../../../../assets/icons/' + this.servicesList[index].urlIcono;
  }

  buildUrlGallery(service: Gallery): string {
    return (
      DocumentsServe.CARDPHOTOS + service.idTarjeta + '/' + service.urlFile
    );
  }

  typeService(service: string): string {
    const tmp = service.split('.');
    const typeService = tmp[tmp.length - 1];
    switch (typeService) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'PNG':
      case 'JPG':
      case 'JPEG':
        return 'image';
        break;
      case 'mp4':
      case 'mvk':
      case 'avi':
      case 'mov':
      case 'MP4':
      case 'MVK':
      case 'AVI':
      case 'MOV':
        return 'video';
        break;
      default:
        return '';
        break;
    }
  }

  typeServiceImage(service: string): boolean {
    const tmp = service.split('.');
    const typeService = tmp[tmp.length - 1];
    if (typeService === 'svg') {
      return true;
    }
    return false;
  }

  goToCenter(): void {
    const position = (window.innerWidth * TabSize.SIZE) / 100;
    this.statusScroll.emit(position);
    this.currentTab = PageTab.SERVICES;
    this.currentTabChange.emit(PageTab.PRESENTATION);
  }
}
